export default "/_next/static/media/news-author-04.7fa30dfc8dadf86419198f9232a15d29.jpg";